import { useState, useEffect } from 'react';
import './AnalyticsProfil.css';
import ConversationCompletedService from '/src/features/supervision/conversations/services/ConversationCompletedService';
import AnalyticsHeader from '../AnalyticsHeader/AnalyticsHeader';
import AnalyticsArray from '../AnalyticsArray/AnalyticsArray';
import ConversationFiltersBar, { DEFAULT_CONVERSATION_FILTERS } from '/src/features/supervision/conversations/components/ConversationFiltersBar/ConversationFiltersBar';
import cleanConversationFilters from '/src/features/supervision/conversations/utils/cleanConversationFilters';
import "tippy.js/dist/tippy.css";

const DEFAULT_PERIOD_DAYS = 30;

const toDateInputValue = (date) => {
        const pad = (value) => String(value).padStart(2, "0");
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    };

    const getDefaultFilters = () => {
        const start = new Date();
        start.setDate(start.getDate() - DEFAULT_PERIOD_DAYS);
        return { ...DEFAULT_CONVERSATION_FILTERS, date_start: toDateInputValue(start) };
    };


function AnalyticsProfil() {
    const { getDashboardAnalytics } = ConversationCompletedService;

    const [analytics, setAnalytics] = useState({ overallScore: 0, criteriaRows: [], categories: [] });
    const [isLoading, setIsLoading] = useState(true);

    const [filters, setFilters] = useState(getDefaultFilters);

    useEffect(() => {
        const fetchAnalytics = async () => {
            setIsLoading(true);

            const cleanedFilters = cleanConversationFilters(filters, DEFAULT_CONVERSATION_FILTERS);

            const [response, error] = await getDashboardAnalytics(cleanedFilters);

            if (error || !response) {
                console.error("Failed to fetch dashboard analytics:", error);
                setIsLoading(false);
                return;
            }

            setAnalytics(response);
            setIsLoading(false);
        };

        fetchAnalytics();
    }, [filters]);

    return (
        <div className="analytics-profil">
            <AnalyticsHeader
                overallScore={analytics.overallScore}
                categories={analytics.categories}
                isLoading={isLoading}
            />
            <br></br>
            <ConversationFiltersBar filters={filters} setFilters={setFilters} />
            <AnalyticsArray criteriaRows={analytics.criteriaRows} isLoading={isLoading} criteriaIds={filters.criteria_ids} criteriaResults={filters.criteria_results} />
        </div >
    );
}

export default AnalyticsProfil;
